import User from './Data/User'

const getStartLocationForUser = (user, preferProfile) => {
	let location
	if (!User.isOnboardingComplete(user)) {
		location = '/onboarding'
	} else if (!user.isActivated || preferProfile) {
		location = User.getUserProfileLocation(user)
	} else {
		location = global.localStorage.getItem('desiredLocation') || '/'
		global.localStorage.removeItem('desiredLocation')
	}
	return location
}

export default getStartLocationForUser



// WEBPACK FOOTER //
// ./src/utilities/getStartLocationForUser.js